// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*,body,html{font-family:Roboto,sans-serif}.btn-outline-success:hover,.btn-warning{color:#fff!important;background-color:#007970!important;border-color:#007970!important}.btn-outline-success,.btn-warning:hover{color:#007970!important;background-color:#fff!important;border-color:#007970!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
